/**
 * @description: 空页面插图 https://www.figma.com/file/3CyYpd5PvPr0i1ah8zdsZx/%E7%A9%BA%E9%A1%B5%E9%9D%A2%E6%B1%87%E6%80%BB?node-id=481-78&t=pfF1QTEUSZ264tz7-0
 */
import TextCn from './images/text.png';
import SlidesCn from './images/slides.png';
import ChannelCn from './images/channel.png';
import RecommendCn from './images/recommend.png';
import OneCn from './images/Empty_1.png';
import OneCom from './images/ComEmpty_1.png';
import TwoCn from './images/Empty_2.png';
import TwoCom from './images/ComEmpty_2.png';
import ThreeCn from './images/Empty_3.png';
import ThreeCom from './images/ComEmpty_3.png';
import FourCn from './images/Empty_4.png';
import FourCom from './images/ComEmpty_4.png';
import FiveCn from './images/Empty_5.png';
import FiveCom from './images/ComEmpty_5.png';
import SixCn from './images/Empty_6.png';
import SixCom from './images/ComEmpty_6.png';
import Document from "./images/document.png"
import Quiz from "./images/quiz.png"
import QuizCo from "./images/quzi-co.png"
import SevenCn from './images/Empty_7.png';
const SevenCom = SevenCn;
type emptyImgMap = {
    [key: string | number]: {
        cn: string;
        co?: string;
        com: string;
    };
};

const emptyImgMap = {
    // 自定义文字
    text: {
        cn: TextCn,
        com: TextCn,
        co: undefined
    },
    // 轮播图
    slides: {
        cn: SlidesCn,
        com: SlidesCn,
        co: undefined
    },
    // 学习项目管理
    channel: {
        cn: ChannelCn,
        com: ChannelCn,
        co: undefined
    },
    // 推荐管理
    recommend: {
        cn: RecommendCn,
        com: RecommendCn,
        co: undefined
    },
    // 编号一
    1: {
        cn: OneCn,
        com: OneCom,
        co: undefined
    },
    // 编号二
    2: {
        cn: TwoCn,
        com: TwoCom,
        co: undefined
    },
    // 编号三
    3: {
        cn: ThreeCn,
        com: ThreeCom,
        co: undefined
    },
    // 编号四
    4: {
        cn: FourCn,
        com: FourCom,
        co: undefined
    },
    // 编号五
    5: {
        cn: FiveCn,
        com: FiveCom,
        co: undefined
    },
    // 编号六
    6: {
        cn: SixCn,
        com: SixCom,
        co: undefined
    },
    7: {
        cn: SevenCn,
        com: SevenCom,
        co: undefined
    },
    document: {
        cn: Document,
        com: Document,
        co: undefined
    },
    quiz: {
        cn: Quiz,
        com: Quiz,
        co: QuizCo,
    }
};

export default emptyImgMap;
